var gettype = Object.prototype.toString
// noinspection JSAnnotator
export default {
  //去除空对象
  removeEmptyArr(newArr) {
    const arr1 = []
    let obj = {}
    for (const j in newArr) {
      for (const prop in newArr[j]) {
        if (prop !== '' && newArr[j][prop] !== '') {
          obj = newArr[j]
        }
      }
      if (Object.keys(obj) !== 0) {
        arr1.push(obj)
      }
    }
    return arr1
  },
  removeEmptyObj(data) {
    for (var key in data) {
      if (data[key] === undefined || data[key] === null || data[key] === '') {
        delete data[key]
      }
    }
    return data
  },

  listAssign(arrA, arrB) {
    this.cleaerObj(arrA)
    if (arrB !== null) {
      Object.keys(arrA).forEach(key => { arrA[key] = arrB[key] || arrA[key] })
    }
  },

  cleaerObj(obj) {
    for (const key in obj) {
      if (gettype.call(obj[key]) === '[object String]') {
        obj[key] = ''
      } else if (gettype.call(obj[key]) === '[object Number]') {
        obj[key] = ''
      } else if (gettype.call(obj[key]) === '[object Null]') {
        obj[key] = null
      } else if (gettype.call(obj[key]) === '[object Array]') {
        obj[key] = []
      } else if (gettype.call(obj[key]) === '[object Object]') {
        obj[key] = {}
      }
    }
  },

  isEmptyObj(obj) {
    if (Object.keys(obj).length === 0) {
      return true
    } else {
      for (const key in obj) {
        if (typeof obj[key] === 'object') {
          return this.isEmptyObj(obj[key])
        } else if (obj[key] !== '' && obj[key] !== null) {
          return false
        }
      }
      return true
    }
  }
}

